/* eslint-disable */
export enum Clients {
  ZION = 'ZION',
  MARKUS = 'MARKUS',
  PONCH = 'PONCH',
}
